/* openClientFolder — JEDEN kontrakt pro otevření klientské složky (overlay).
 *
 * PROČ: složka není routa, otevírá se window eventem `open-client-folder`. Dřív
 * každý vstupní bod dispatchoval ručně jen `{ contactId }`, takže se nedala
 * otevřít konkrétní sekce a některé cesty (`/klienti?focus=…`) nikdo nekonzumoval
 * → klik „nic neudělal". Tohle je jednotné místo: payload nese clientId + volitelně
 * tab/section/source/returnTo/entityId. ClientFolderHost payload konzumuje.
 *
 * `tab` a `section` jsou synonyma (Host bere `tab || section`) — drž oba kvůli
 * čitelnosti volání. Vrací true, když se podařilo dispatchnout (validní id).
 */
export function openClientFolder({
  contactId,
  clientId,
  tab,
  section,
  source,
  returnTo,
  entityId,
} = {}) {
  const id = contactId || clientId;
  if (!id) return false;
  if (typeof window === "undefined" || typeof window.dispatchEvent !== "function") return false;
  window.dispatchEvent(
    new CustomEvent("open-client-folder", {
      detail: {
        contactId: id,
        tab: tab || section || null,
        section: section || tab || null,
        source: source || null,
        returnTo: returnTo || null,
        entityId: entityId || null,
      },
    })
  );
  return true;
}
